export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "YOUR_CLIENT_ID",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || "YOUR_TENANT_ID"}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const graphScopes = {
  scopes: ["User.Read", "profile", "email", "openid"],
};

export const graphEndpoints = {
  me: "https://graph.microsoft.com/v1.0/me",
  photo: "https://graph.microsoft.com/v1.0/me/photo/$value",
  meExtended:
    "https://graph.microsoft.com/v1.0/me?$select=displayName,givenName,surname,jobTitle,department,companyName,mail,mobilePhone,businessPhones,officeLocation,city,country,userPrincipalName,onPremisesExtensionAttributes",
};
